export const validateConsentForm = (formData) => {
  const errors = {};

  const requiredFields = [
    { key: 'consultant', label: 'Consultant Name' },
    { key: 'anaesthesia_care_plan', label: 'Anaesthesia Care Plan' },
    { key: 'dr_name', label: 'Doctor Name' },
  ];

  requiredFields.forEach(({ key, label }) => {
    if (!formData[key] || String(formData[key]).trim() === '') {
      errors[key] = `${label} is required`;
    }
  });

  return errors;
};
